<div class="page-wrapper">
  <div class="heading" i18n>Select services</div>
  <p class="page-content" i18n>
    Below are the list of services offered by the outlet. Click on the tile to
    select your preferred services.
  </p>

  <!-- Chip showing number of selected services -->
  @if (selectedCount > 0) {
  <mat-chip-set class="selected-chip">
    <mat-chip class="custom-chip" [removable]="true" (removed)="clearAll()">
      <ng-container i18n="@@chipLabel">
        {{ selectedCount }} service{{ selectedCount > 1 ? 's' : '' }} added
      </ng-container>
      <button matChipRemove>
        <mat-icon>close</mat-icon>
      </button>
    </mat-chip>
  </mat-chip-set>
  }


  @if (isLoading && !loadServices) {
  <div class="loading-spinner">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
  }
  @else{
  <!-- Services cards -->
  @for (service of services; track service.id) {
  <mat-card class="service-card">
    <mat-card-header class="card-header">
      <mat-card-title class="mat-title">{{ service.name }}</mat-card-title>

      @if (service.unitPrice) {
      <span class="price-pill">
        @if (service.unitPrice.grossPrice) {
        {{ service.unitPrice.grossPrice | currency:service.unitPrice.currency:'symbol':'1.0-0' }}
        <span class="vat-label" i18n>incl. VAT</span>
        } @else {
        {{ service.unitPrice.netPrice | currency:service.unitPrice.currency:'symbol':'1.0-0' }}
        <span class="vat-label" i18n>excl. VAT</span>
        }
      </span>
      }
    </mat-card-header>

    <!-- Divider -->
    <mat-divider class="custom-divider"></mat-divider>

    <mat-card-content class="card-content">
      <p>{{ service.descriptionLong }}</p>
    </mat-card-content>

    <mat-card-actions class="card-actions">
      <button mat-button class="remove-btn" (click)="removeService(service?.id)" [disabled]="!isSelected(service)" i18n>
        Remove
      </button>
      <button mat-raised-button class="add-btn" [ngClass]="{ 'added': isSelected(service) }"
        (click)="toggleService(service)" [disabled]="isSelected(service)">
        @if (isSelected(service)) {
        <span i18n>Added</span>
        } @else {
        <span i18n>Add</span>
        }
      </button>
    </mat-card-actions>
  </mat-card>
  }
  }

  @if(this.services.length === 0 && loadServices) {
    <div class="no-services" i18n>No services available for the selected vehicle type in the selected outlet.</div>
  }
</div>